import React from "react";
import Hero from "components/hero/Hero";
import Footer from "components/footers/FiveColumnDark";
import ReinforcementInspection from "components/services/ReinforcementInspection";
import GlobalStyle from "helpers/GlobalStyle";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import useScreenSize from "helpers/useScreenSize";
export default () => {
  const { isXs } = useScreenSize();
  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <ReinforcementInspection isXs={isXs} />
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
